import { getConfig } from '@cian/config/browser';
import { axiosInstance } from './axiosInstance';

export const sendCode = (uuid: string, code: string, advAgreement?: boolean): Promise<{ ok: boolean }> => {
  const config = getConfig();
  const mpAuthUrl = config.get<string>('marketplace-auth.mpAuthUrl');

  return axiosInstance
    .post(
      `${mpAuthUrl}/code`,
      {
        uuid,
        code,
        authContext: {
          advAgreement,
        },
      },
      { withCredentials: true },
    )
    .then(r => r.data);
};
